import { LanguageCode } from '../types';

// URL search parameters interface
interface URLSearchParams {
  [key: string]: string;
}

// Breakpoint names
type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const generalController = (function () {

  const getUrlPath = (): string[] => {
    return window.location.href.split('/');
  };

  // Find all url parameters
  const getSearchParameters = (): URLSearchParams => {
    const prmstr = window.location.search.substr(1);
    return (prmstr !== null && prmstr !== "") ? transformToAssocArray(prmstr) : {};
  };

  const transformToAssocArray = (prmstr: string): URLSearchParams => {
    let params: URLSearchParams = {};
    const prmarr = prmstr.split("&");
    for (let i = 0; i < prmarr.length; i++) {
      const tmparr = prmarr[i].split("=");
      params[tmparr[0]] = tmparr[1];
    }
    return params;
  };

  return {
    // Detect current language
    detectLanguage: function (): LanguageCode {
      const urlPathArr = getUrlPath();
      const params = getSearchParameters();

      if (urlPathArr.includes('fr')) {
        return 'fr';
      } else if (params.lang === 'fr') {
        return 'fr';
      } else {
        return 'en';
      }
    },
    // Return URL search params
    getURLSearchParams: function (): URLSearchParams {
      return getSearchParameters();
    },
    // Get the normal HTML meta tag value.
    getMetatagValue: function (name: string): string | null {
      const meta = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
      if (meta) {
        return meta.content;
      } else {
        console.log('Error: Meta tag not found in getMetatagValue in generalController');
        return null;
      }
    },
    // Get media query in the current viewport.
    getMediaQuery: function(): Breakpoint | null {
      const breakpoints: Record<Breakpoint, number> = {
        xs: 0,
        sm: 480,
        md: 767,
        lg: 1025,
        xl: 1200
      };
  
      const keys = Object.keys(breakpoints) as Breakpoint[];
      let currentBP: Breakpoint | null = null;
  
      for (let i = keys.length - 1; i >= 0; i--) {
        if (window.matchMedia(`(min-width: ${breakpoints[keys[i]]}px)`).matches) {
          currentBP = keys[i];
          break;
        }
      }
  
      return currentBP;
    },
  };
})();

export default generalController;
